












import Vue from 'vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';

export default Vue.extend({
  name: 'App',
  components: {
    CtrlMessageDialog,
  },
  data: () => ({
    timeoutId: 0,
    messageShow: false,
    messageId: '',
  }),
  computed: {
    sec() {
      return process.env.VUE_APP_EXPIRATION_TIME;
    },
    events() {
      return ['keydown', 'mousemove', 'click'];
    },
    excludePath() {
      return ['/login', '/forgot-password', '/change-password'];
    },
  },
  methods: {
    // タイマー設定
    setTimer() {
        this.timeoutId = setTimeout(() => {
          if (!this.excludePath.includes(window.location.pathname)) {
            this.messageId = 'KI_W015';
            this.messageShow = true;
            return;
          }
        }, this.sec * 1000);

    },
    resetTimer() {
        clearTimeout(this.timeoutId);
        this.setTimer();
    },
    handleOKmessage() {
      if (this.messageId == 'KI_W015') {
        this.$store.dispatch('common/logout');
      }
      this.messageId = '';
      this.messageShow = false;
    }
  },
  created() {
    const html = document.documentElement;
    html.setAttribute('lang', 'ja');
  },
  mounted() {
    // イベント設定
    for (const event of this.events) {
      addEventListener(event, this.resetTimer, false);
    }
  },
});
